document.addEventListener("click", function (e) {
  const btn = e.target.closest("[bss-b2b-btn-quickview]");

  if (btn) {
    setTimeout(() => {
        document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"));
    }, 1000);
  }
});